import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, Build, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { a as attachComponent } from './framework-delegate.js';
var tabCss = ":host(.tab-hidden){display:none !important}";

var Tab = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Tab, _HTMLElement);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();

    _this.loaded = false;
    /** @internal */

    _this.active = false;
    return _this;
  }

  _createClass(Tab, [{
    key: "componentWillLoad",
    value: function () {
      var _componentWillLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Build.isDev) {
                  if (this.component !== undefined && this.el.childElementCount > 0) {
                    console.error('You can not use a lazy-loaded component in a tab and inlined content at the same time.' + "- Remove the component attribute in: <ion-tab component=\"".concat(this.component, "\">") + " or" + "- Remove the embedded content inside the ion-tab: <ion-tab></ion-tab>");
                  }
                }

                if (!this.active) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.setActive();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillLoad() {
        return _componentWillLoad.apply(this, arguments);
      }

      return componentWillLoad;
    }()
    /** Set the active component for the tab */

  }, {
    key: "setActive",
    value: function () {
      var _setActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.prepareLazyLoaded();

              case 2:
                this.active = true;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setActive() {
        return _setActive.apply(this, arguments);
      }

      return setActive;
    }()
  }, {
    key: "changeActive",
    value: function changeActive(isActive) {
      if (isActive) {
        this.prepareLazyLoaded();
      }
    }
  }, {
    key: "prepareLazyLoaded",
    value: function prepareLazyLoaded() {
      if (!this.loaded && this.component != null) {
        this.loaded = true;

        try {
          return attachComponent(this.delegate, this.el, this.component, ['ion-page']);
        } catch (e) {
          console.error(e);
        }
      }

      return Promise.resolve(undefined);
    }
  }, {
    key: "render",
    value: function render() {
      var tab = this.tab,
          active = this.active,
          component = this.component;
      return h(Host, {
        role: "tabpanel",
        "aria-hidden": !active ? 'true' : null,
        "aria-labelledby": "tab-button-".concat(tab),
        class: {
          'ion-page': component === undefined,
          'tab-hidden': !active
        }
      }, h("slot", null));
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "active": ["changeActive"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return tabCss;
    }
  }]);

  return Tab;
}(HTMLElement);

Tab = /*@__PURE__*/proxyCustomElement(Tab, [1, "ion-tab", {
  "active": [1028],
  "delegate": [16],
  "tab": [1],
  "component": [1],
  "setActive": [64]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-tab"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-tab":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Tab);
        }

        break;
    }
  });
}

var IonTab = Tab;
var defineCustomElement = defineCustomElement$1;
export { IonTab, defineCustomElement };